 /* eslint-disable */
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useWallet } from 'use-wallet'

import metamaskLogo from '../../assets/img/metamask-fox.svg'
import walletConnectLogo from '../../assets/img/wallet-connect.svg'

import Button from '../Button'
import Modal, { ModalProps } from '../Modal'
import ModalActions from '../ModalActions'
import ModalContent from '../ModalContent'
import ModalTitle from '../ModalTitle'
import Spacer from '../Spacer'

import WalletCard from './components/WalletCard'

const WalletProviderModal: React.FC<ModalProps> = ({ onDismiss }) => {
  const { account, connect } = useWallet()
  useEffect(() => {
    if (account) {
      onDismiss()
    }
  }, [account, onDismiss,])

  return (
    <Modal>
      <ModalTitle text="Select a wallet provider." />
        <StyledGuide>⚠️Tune your network to Rinkeby⚠️</StyledGuide>
      <ModalContent>
        <StyledWalletsWrapper>
          <StyledWalletCard>
            <WalletCard
              icon={<img src={metamaskLogo} style={{ height: 32 }} />}
              onConnect={() => connect('injected')}
              title="Metamask"
            />
          </StyledWalletCard>
        </StyledWalletsWrapper>
      </ModalContent>
      <ModalActions>
        <Button text="Cancel" variant="secondary" onClick={onDismiss} />
      </ModalActions>
    </Modal>
  )
}

const StyledWalletsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}px) {
    flex-direction: column;
    flex-wrap: none;
  }
`

const StyledWalletCard = styled.div`
  flex-basis: calc(100% - ${(props) => props.theme.spacing[2]}px);
`
const StyledGuide = styled.div`
  align-items: center;
  color: ${props => props.theme.color.red[500]};
  display: flex;
  font-size: 16px;
  font-weight: 700;
  height: 44px;
  justify-content: center;
`
const StyledGuide2 = styled.div`
  align-items: center;
  color: ${props => props.theme.color.grey[500]};
  display: flex;
  font-size: 14px;
  font-weight: 700;
  height: 44px;
  justify-content: center;
  ]
`


const StyledWrapper = styled.div`
  display: block;
  aligin-items: center;
  justify-content: center;
`

export default WalletProviderModal

/*
<Spacer size="sm" />
          <StyledWalletCard>
            <WalletCard
              icon={<img src={walletConnectLogo} style={{ height: 24 }} />}
              onConnect={() => connect('walletconnect')}
              title="WalletConnect"
            />
          </StyledWalletCard>


          <StyledWrapper>
          <Button
            onClick={() => {
              window.open(`#`, "_blank")
            }}
            text="Testnet Guide"
            variant="secondary"
          />
        </StyledWrapper>
*/